
import { Notification } from 'element-ui'
import util from './util'
import {operRoleLists } from '../api/api'

// 接口映射
const apiMap = {
  operRoleLists
}

/**
 * 公共通用数据请求方法
 * @param {string} apiName 接口名称
 * @param {object} params 请求参数
 * @returns Promise<返回接口数据>
 */
export async function requestData (apiName, params) {
  try {
    const api = apiMap[apiName]

    if (!api) {
      Notification.error({
        title: '失败',
        message: '接口未配置',
        type: 'error'
      })
      return null
    }

    const res = await api(params)
    let data = res.data || { c: -1 }

    if (!data.c) {
      return data.d
    } else {
      Notification.error({
        title: '失败',
        message: util.getErrorMsg(data.c),
        type: 'error'
      })
      return null
    }
  } catch (error) {
    Notification.error({
      title: '失败',
      message: '服务器出错了',
      type: 'error'
    })
    return null
  }
}



// WEBPACK FOOTER //
// ./src/script/request.js